import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-shared-point-circle',
  template: `
    <ng-container *ngIf="checked; else unchecked">
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="15" cy="15" r="12.5" fill="white" stroke="#6A4C93" />
        <circle cx="15" cy="15" r="10" fill="#6A4C93" />
      </svg>
    </ng-container>
    <ng-template #unchecked>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="15" cy="15" r="12.5" fill="white" stroke="#DEC7FF" />
      </svg>
    </ng-template>
  `,
  styles: [],
})
export class SharedPointCircleComponent {
  @Input() checked: boolean = false;
}
